import { render, staticRenderFns } from "./missingHistoricalData.vue?vue&type=template&id=688fcb3e"
import script from "./missingHistoricalData.vue?vue&type=script&lang=js"
export * from "./missingHistoricalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports